module.exports = __webpack_public_path__ + "static/hero-phone-2-2e0c109d440422a1c164bffa7ea57bb7.png";